import { WishlistState } from '../types/WishlistState'
import { GetterTree } from 'vuex'

export const getters: GetterTree<WishlistState, any> = {
    getWishlist: state => state.products,
    getWishlistLength: state => state.products.length
}
